export const Breakpoints = {
  "xs": 640,
  // and below -> Phones vertically
  "sm": 768,
  // and below -> Phones horizontally
  "md": 1024,
  // and below -> Tablets vertically or large phones horizontally
  "lg": 1280,
  // and below -> Tablets horizontally or large Tablets vertically, e.g., iPad Pro
  "xl": 1920
  // and below -> Laptops and Desktops
};
